export default {
      id: "time-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#time",
      toString: function () {
        return this.url;
      }
    }